import ComponentsBatchFunctions from '../../privates/utils/componentsBatchFunctions';
import * as members from '../../privates/privateMembers';


/**
 * @mixin ContainableMixin
 * @summary Provides functionality for elements that can contain other elements.
 * @description
 *  Some elements, such as pages, headers, footers, and boxes, can contain
 *  other elements. This occurs when you drag an element onto a container
 *  element and [attach it](https://www.wix.com/support/html5/article/attaching-elements-to-a-box).
 *  These attached elements are considered the parent element's children. Some
 *  actions performed on the parent, such as [`hiding`]($w.HiddenMixin.html#hide),
 *  affect the element's children as well.
 * @memberof $w
 */
class ContainableMixin {

    /**
     * @member children
     * @label property
     * @syntax
     * get children(): Element[]
     * @summary Gets an array of the elements that are contained within the element.
     * @description
     *  Some elements, such as pages, headers, footers, and boxes, can contain
     *  other elements. This occurs when you drag an element onto a container
     *  element and [attach it](https://www.wix.com/support/html5/article/attaching-elements-to-a-box).
     *  These attached elements are considered the parent element's children.
     * @type {$w.Element[]}
     * @default An empty array
     * @snippet [Containable-children.es6=Get an element's children]
     * @see [parent]($w.Node.html#parent)
     * @memberof $w.ContainableMixin
     * @readonly
     */
    get children() {
        const compId = members._compId.get(this);
        if (compId === 'default') {
            return;
        }
        const childElements = [];
        const RMI = members._RMI.get(this);
        const wixSelector = members._wixSelector.get(this);
        const controllerId = members._controllerId.get(this);
        const childrenIds = RMI.getChildren(compId);
        const children = childrenIds.map(RMI.getComp.bind(RMI));

        children.forEach((child, index) => {
            childElements.push(wixSelector.getInstance(RMI, child.type, childrenIds[index], controllerId));
        }, this);
        return ComponentsBatchFunctions.expose(childElements);
    }
}

export default ContainableMixin;
